import get from 'lodash/get';

export const selectGroupVulnsIsFetching = (state) => get(state, 'groupVulns.isFetching', false);
export const selectGroupVulnsError = (state) => get(state, 'groupVulns.error', false);
export const selectGroupVulnsErrorMessage = (state) => get(state, 'groupVulns.errorMessage', '');
export const selectGroupVulnsLastAction = (state) => get(state, 'groupVulns.lastAction', null);
export const selectExploreGroup = (state) => state.groupVulns?.explore;
export const selectIsExploreGroupOpen = (state) => !!state.groupVulns?.explore?.isOpen;
export const selectExploreGroupActiveTab = (state) => state.groupVulns?.explore?.activeTab ?? 0;
export const selectExploreGroupPayload = (state) => state.groupVulns?.explore?.payload;
export const selectExploreGroupHosts = (state) => state.groupVulns?.explore?.hosts ?? [];
export const selectIsExploreGroupHostsFetching = (state) => !!state.groupVulns?.explore?.isFetchingHosts;
export const selectExploreGroupHostsPage = (state) => {
  const page = get(state, 'groupVulns.explore.hostsPage', 1);
  return Number.isFinite(page) && page >= 1 ? Math.trunc(page) : 1;
};
export const selectExploreGroupHostsCount = (state) => {
  const metaCount = get(state, 'groupVulns.explore.hostsMeta.hostCount', null);
  if (typeof metaCount === 'number') return metaCount;
  const hosts = selectExploreGroupHosts(state);
  return Array.isArray(hosts) ? hosts.length : 0;
};
export const selectExploreGroupServices = (state) => state.groupVulns?.explore?.services ?? [];
export const selectIsExploreGroupServicesFetching = (state) => !!state.groupVulns?.explore?.isFetchingServices;
export const selectExploreGroupServicesPage = (state) => {
  const page = get(state, 'groupVulns.explore.servicesPage', 1);
  return Number.isFinite(page) && page >= 1 ? Math.trunc(page) : 1;
};
export const selectExploreGroupServicesCount = (state) => {
  const metaCount = get(state, 'groupVulns.explore.servicesMeta.serviceCount', null);
  if (typeof metaCount === 'number') return metaCount;
  const services = selectExploreGroupServices(state);
  return Array.isArray(services) ? services.length : 0;
};
export const selectShowUngroupConfirmationModal = (state) => !!state.groupVulns?.explore?.showUngroupConfirmationModal;
export const selectExploreGroupSelectedHostIds = (state) => state.groupVulns?.explore?.selectedHostIds ?? [];
export const selectExploreGroupSelectedServiceIds = (state) => state.groupVulns?.explore?.selectedServiceIds ?? [];

export const selectExploreGroupSelectedHostObjects = (state) => {
  const hosts = state.groupVulns?.explore?.hosts ?? [];
  const selectedIds = state.groupVulns?.explore?.selectedHostIds ?? [];
  return hosts
    .map((row) => row?.value ?? row)
    .filter(Boolean)
    .filter((h) => {
      const id = String(h?._id ?? h?.id ?? '');
      return id !== '' && selectedIds.includes(id);
    });
};

export const selectExploreGroupSelectedServiceObjects = (state) => {
  const services = state.groupVulns?.explore?.services ?? [];
  const selectedIds = state.groupVulns?.explore?.selectedServiceIds ?? [];
  return services
    .map((row) => row?.value ?? row)
    .filter(Boolean)
    .filter((s) => {
      const id = String(s?._id ?? s?.id ?? '');
      return id !== '' && selectedIds.includes(id);
    });
};

export const selectExploreGroupSelectedHostsTags = (state) => {
  const selectedHosts = selectExploreGroupSelectedHostObjects(state);
  return selectedHosts.flatMap((h) => (Array.isArray(h?.tags) ? h.tags : []));
};

export const selectExploreGroupSelectedServicesTags = (state) => {
  const selectedServices = selectExploreGroupSelectedServiceObjects(state);
  return selectedServices.flatMap((s) => (Array.isArray(s?.tags) ? s.tags : []));
};
